/** Shared invoices list page size (POS `start`/`size` → IMS BOP). Keep free of store imports. */
export const INVOICES_PAGE_SIZE = 200;
